import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutosizeModule } from 'ngx-autosize';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TextFieldModule } from '@angular/cdk/text-field';

import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { ClickOutsideModule } from 'ng-click-outside';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import {
  FormCheckboxComponent,
  FormSelectComponent,
  FormOptionComponent,
  FormSwitchComponent,
} from './form-controls';
import {
  CheckboxComponent,
  CheckmarkComponent,
  InputComponent,
  InputHighlightComponent,
  InputPreviewComponent,
  SwitchComponent,
  SelectComponent,
  ChipsInputComponent,
} from './controls';
import {
  NavBotComponent,
  NavBrandComponent,
  NavMenuCollapsedDirective,
  MenuUserComponent,
  MenuModuleComponent,
} from './navigation';
import {
  PaginationSettingsComponent,
  TableActionsComponent,
} from './table-components';
import { ExpansionPanelComponent } from './controls/expansion-panel/expansion-panel.component';
import { SuggestPipe } from './pipes/suggest.pipe';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { HintDirective } from './directives/hint.directive';
import { ContenteditableModule } from '@ng-stack/contenteditable';
import { CardComponent } from './components/card/card.component';
import { PortalModule } from '@angular/cdk/portal';
import { FileUploadModule } from 'ng2-file-upload';
import { OverlayModule } from '@angular/cdk/overlay';
import { PopupDirective } from './directives/popup.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { DateRangePickerComponent } from './controls/date-range-picker/date-range-picker.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { TableLoaderDirective } from './directives/table-loader.directive';
import { MobileHeaderComponent } from './navigation/mobile-header/mobile-header.component';
import { RouterModule } from '@angular/router';
import {
  FacebookConnectionModalComponent,
  TelegramConnectionModalComponent,
  InstagramConnectionModalComponent,
  SkypeConnectionModalComponent,
  ViberConnectionModalComponent,
  EmailConnectionModalComponent,
  TwilioConnectionModalComponent,
  TextmagicConnectionModalComponent,
  ShopifyConnectionModalComponent,
} from './modals/connections';
import { LinkHighlightPipe } from './pipes/link-highlight.pipe';
import { SanitizePipe } from './pipes/sanitize.pipe';
import { ColorPickerModule } from 'ngx-color-picker';
import { SlackConnectionModalComponent } from './modals/connections/slack-connection-modal/slack-connection-modal.component';
import { WidgetConnectionModalComponent } from './modals/connections/widget-connection-modal/widget-connection-modal.component';
import { DiscordConnectionModalComponent } from './modals/connections/discord-connection-modal/discord-connection-modal.component';
import { SnackBarComponent } from './modals/snack-bar/snack-bar.component';
import { FormInputEditorComponent } from './form-controls/form-input-editor/form-input-editor.component';
import { AngularEditorModule } from '@kolkov/angular-editor';

@NgModule({
  declarations: [
    CheckboxComponent,
    CheckmarkComponent,
    InputComponent,
    InputHighlightComponent,
    InputPreviewComponent,
    NavBotComponent,
    NavBrandComponent,
    NavMenuCollapsedDirective,
    MenuUserComponent,
    MenuModuleComponent,
    PaginationSettingsComponent,
    TableActionsComponent,
    ExpansionPanelComponent,
    SwitchComponent,
    FormCheckboxComponent,
    FormSelectComponent,
    FormOptionComponent,
    SuggestPipe,
    HintDirective,
    CardComponent,
    PopupDirective,
    FormSwitchComponent,
    DateRangePickerComponent,
    SelectComponent,
    TableLoaderDirective,
    MobileHeaderComponent,
    FacebookConnectionModalComponent,
    TelegramConnectionModalComponent,
    InstagramConnectionModalComponent,
    SkypeConnectionModalComponent,
    ViberConnectionModalComponent,
    EmailConnectionModalComponent,
    TwilioConnectionModalComponent,
    LinkHighlightPipe,
    ChipsInputComponent,
    SanitizePipe,
    TextmagicConnectionModalComponent,
    ShopifyConnectionModalComponent,
    SlackConnectionModalComponent,
    WidgetConnectionModalComponent,
    DiscordConnectionModalComponent,
    SnackBarComponent,
    FormInputEditorComponent,
  ],
  imports: [
    CommonModule,
    AutosizeModule,
    DragDropModule,
    MatMenuModule,
    MatIconModule,
    ClickOutsideModule,
    MatTooltipModule,
    MatDialogModule,
    NgxTippyModule,
    ContenteditableModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    PortalModule,
    FileUploadModule,
    NgxPaginationModule,
    OrderModule,
    DigitOnlyModule,
    RouterModule,
    ClipboardModule,
    TextFieldModule,
    ColorPickerModule,
    AngularEditorModule,
  ],
  exports: [
    CommonModule,
    AutosizeModule,
    DragDropModule,
    CheckboxComponent,
    CheckmarkComponent,
    InputComponent,
    InputHighlightComponent,
    InputPreviewComponent,
    SwitchComponent,
    NavBotComponent,
    NavBrandComponent,
    NavMenuCollapsedDirective,
    MenuUserComponent,
    MenuModuleComponent,
    PaginationSettingsComponent,
    TableActionsComponent,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    ClickOutsideModule,
    MatDialogModule,
    ExpansionPanelComponent,
    FormCheckboxComponent,
    FormSelectComponent,
    FormOptionComponent,
    NgxTippyModule,
    HintDirective,
    ContenteditableModule,
    CardComponent,
    OverlayModule,
    PopupDirective,
    FormsModule,
    ReactiveFormsModule,
    FormSwitchComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    DateRangePickerComponent,
    SelectComponent,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    PortalModule,
    FileUploadModule,
    NgxPaginationModule,
    OrderModule,
    DigitOnlyModule,
    TableLoaderDirective,
    MobileHeaderComponent,
    ClipboardModule,
    TextFieldModule,
    LinkHighlightPipe,
    ChipsInputComponent,
    SanitizePipe,
    ColorPickerModule,
    FormInputEditorComponent,
  ],
})
export class SharedModule {}
